// extracted by mini-css-extract-plugin
export var bottomLeft = "CardLogo-module--bottomLeft--28a51";
export var bottomRight = "CardLogo-module--bottomRight--fe04d";
export var logo = "CardLogo-module--logo--84a9a";
export var logoContainer = "CardLogo-module--logoContainer--4ea68";
export var topLeft = "CardLogo-module--topLeft--0aec1";
export var topRight = "CardLogo-module--topRight--ef15d";